/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowincluded2Inputs */

const en_aiflowincluded2 = /** @type {(inputs: Aiflowincluded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`included`)
};

const de_aiflowincluded2 = /** @type {(inputs: Aiflowincluded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inklusive`)
};

/**
* | output |
* | --- |
* | "included" |
*
* @param {Aiflowincluded2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowincluded2 = /** @type {((inputs?: Aiflowincluded2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowincluded2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowincluded2(inputs)
	return de_aiflowincluded2(inputs)
});
export { aiflowincluded2 as "aiFlowIncluded" }